import { InjectionToken } from '@angular/core';

import { MessageType } from './message';

export interface ErrorHandlerConfig {
  showErrorInConsole: boolean;
  onErrorMessageType: MessageType;
}

export let ERROR_HANDLER_CONFIG = new InjectionToken<ErrorHandlerConfig>('errorHandler.config');
